"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigureCounter = void 0;
var react_1 = require("react");
var date_fns_1 = require("date-fns");
var lodash_1 = __importDefault(require("lodash"));
var helpers_1 = require("../helpers");
var types_1 = require("../types");
var useConfigureCounter = function (_a) {
    var start = _a.start, end = _a.end, _b = _a.currentDateTimeOffset, currentDateTimeOffset = _b === void 0 ? 0 : _b;
    var timerNow = (0, react_1.useRef)((0, helpers_1.getNewDateWithOffset)(currentDateTimeOffset));
    var _c = (0, react_1.useState)({
        countdownDate: "",
        countdownHeader: "",
        status: undefined,
        previousStatus: undefined,
    }), internalState = _c[0], setInternalState = _c[1];
    var configureCounter = (0, react_1.useCallback)(function () {
        if (!start || !end)
            return;
        timerNow.current = (0, helpers_1.getNewDateWithOffset)(currentDateTimeOffset);
        var parsedNow = (0, date_fns_1.parseISO)(timerNow.current.toISOString());
        var parsedStart = (0, date_fns_1.parseISO)(start.toISOString());
        var parsedEnd = (0, date_fns_1.parseISO)(end.toISOString());
        switch (true) {
            case (0, date_fns_1.isBefore)(parsedNow, parsedStart):
                if ((internalState === null || internalState === void 0 ? void 0 : internalState.status) !== types_1.LotStatus.AWAITING || (internalState === null || internalState === void 0 ? void 0 : internalState.status) === undefined || (internalState === null || internalState === void 0 ? void 0 : internalState.countdownDate) !== start.toISOString()) {
                    setInternalState(function (current) {
                        var newState = __assign(__assign({}, current), { previousStatus: current.status, status: types_1.LotStatus.AWAITING, countdownHeader: "Starting in", countdownDate: start.toISOString(), countdownKey: types_1.LotStatus.AWAITING });
                        if (lodash_1.default.isEqual(newState, current)) {
                            return current;
                        }
                        return newState;
                    });
                }
                break;
            case (0, date_fns_1.isAfter)(parsedNow, parsedStart) && (0, date_fns_1.isBefore)(parsedNow, parsedEnd):
                if ((internalState === null || internalState === void 0 ? void 0 : internalState.status) !== types_1.LotStatus.STARTED || (internalState === null || internalState === void 0 ? void 0 : internalState.status) === undefined || (internalState === null || internalState === void 0 ? void 0 : internalState.countdownDate) !== end.toISOString()) {
                    setInternalState(function (current) {
                        var newState = __assign(__assign({}, current), { previousStatus: current.status, status: types_1.LotStatus.STARTED, countdownHeader: "Closing in", countdownDate: end.toISOString(), countdownKey: types_1.LotStatus.STARTED });
                        if (lodash_1.default.isEqual(newState, current)) {
                            return current;
                        }
                        return newState;
                    });
                }
                break;
            case (0, date_fns_1.isEqual)(parsedNow, parsedEnd) || (0, date_fns_1.isAfter)(parsedNow, parsedEnd):
                if ((internalState === null || internalState === void 0 ? void 0 : internalState.status) !== types_1.LotStatus.COMPLETED || (internalState === null || internalState === void 0 ? void 0 : internalState.status) === undefined || (internalState === null || internalState === void 0 ? void 0 : internalState.countdownDate) !== end.toISOString()) {
                    setInternalState(function (current) {
                        var newState = __assign(__assign({}, current), { previousStatus: current.status, status: types_1.LotStatus.COMPLETED, countdownHeader: "Closing in", countdownDate: end.toISOString(), countdownKey: types_1.LotStatus.COMPLETED });
                        if (lodash_1.default.isEqual(newState, current)) {
                            return current;
                        }
                        return newState;
                    });
                }
                break;
        }
    }, [start, end, currentDateTimeOffset, internalState === null || internalState === void 0 ? void 0 : internalState.status, internalState === null || internalState === void 0 ? void 0 : internalState.countdownDate]);
    (0, react_1.useEffect)(function () {
        configureCounter();
        var interval = setInterval(function () {
            configureCounter();
        }, 1000);
        return function () {
            clearInterval(interval);
        };
    }, [configureCounter]);
    return internalState;
};
exports.useConfigureCounter = useConfigureCounter;
